import { Component, Input } from '@angular/core';
import {DatePipe} from "@angular/common";
import { Account } from '../../models/accountmodel';
import { Acct } from '../../models/acctmodel';
import { AccountUpdate } from '../../models/accountupdatemodel';
import { Topup } from '../../models/topupmodel';
import { accountService }   from '../../services/account.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { AcctResponse } from '../../models/accountresponse';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import { CurrencyPipe } from '@angular/common';
//import { DataTableResource } from 'angular-2-data-table';

@Component({
  templateUrl: './account.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [accountService]
})

export class AccountComponent {
  @Input() responseObj: Session;
  public accounts: Account[];
  public data;
  public acct: Acct;
  public acctupdate: AccountUpdate;
  public acctresp : AcctResponse;
  public topup: Topup;
  errorMessage: string;
  public itemResource;
  items = [];
  itemCount = 0;


  constructor(public _accountService: accountService, public router: Router, public sharedservice: SharedService) {
    
  }

  ngOnInit()
  {   
      // call the method on initial load of page to bind dropdown
      this.getAccounts();           
      this.acct = new Acct();
      this.topup = new Topup();
      this.acctupdate = new AccountUpdate();
  }

  postAccount(isValid: boolean){
    if(isValid){
      this._accountService.postAccount(this.acct).subscribe(res => this.handlePostResponse(res), error => this.errorMessage = <any>error);
      this.getAccounts();
    }
  }

 updateAccount(isValid: boolean){
    if(isValid){      
      this._accountService.updateAccount(this.acctupdate).subscribe(res => res, error => this.errorMessage = <any>error);      
      this.getAccounts();
    }
  }

  topupAccount(isValid: boolean){
    if(isValid){
      this.topup.createdby = this.sharedservice.session.account_username;
      this._accountService.topupAccount(this.topup).subscribe(res => res, error => this.errorMessage = <any>error);
      this.getAccounts();
    }
  } 

  //Get the list of accounts
  getAccounts() {
      this._accountService.getAccounts().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

   //Get the list of accounts
  retrieveAccount(storeid) {     
      var racct = this.accounts.find(a => a.storeid == storeid);
      this.acctupdate.accounttype = racct.accounttype;     
      this.acctupdate.password = "";//racct.password;
      this.acctupdate.role = racct.role;
      this.acctupdate.storeid = racct.storeid;
      this.acctupdate.commissionmodel = racct.commissionmodel;
      this.acctupdate.notificationurl = racct.notificationurl;
      this.acctupdate.rate = racct.rate;
   }

  
  handleResponse(result){
    this.accounts = result;
    this.data = result;  
  }

  handlePostResponse(result){
    this.acctresp = result;
  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/account/account.component.ts